import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';
import type StoreService from '@ember-data/store';
import type ObservableDocumentModel from 'tio-data/models/observable-document';

export default class AuthenticatedReimaginedDocumentsIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;
  @service declare store: StoreService;

  async model() {
    const dataSourceInfo = await this.reimaginedData.getDataSourceInfo();
    const personId = this.sessionContext.person.id;

    let observableDocuments: ObservableDocumentModel[] = [];
    if (personId && !this.reimaginedData.isDemoMode) {
      try {
        const results = await this.store.query<ObservableDocumentModel>('observable-document', {
          filter: { person: personId },
          include: 'observable-asset',
          sort: '-created-at',
          page: { limit: 25 },
        });
        observableDocuments = [...results];
      } catch {
        // Fail gracefully — show demo/placeholder data
      }
    }

    return { dataSourceInfo, observableDocuments };
  }
}
